import script from "./Kurse.vue?vue&type=script&setup=true&lang=js"
export * from "./Kurse.vue?vue&type=script&setup=true&lang=js"

import "./Kurse.vue?vue&type=style&index=0&id=2133310e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2133310e"]])

export default __exports__